@if (state$ | async; as state) {
  @if (state.route !== currentRoute) {
    <p>
      <portal-link [params]="state.params" [route]="state.route">
        <small>
          <i class="far fa-long-arrow-left me-1"></i>
          <span>{{ 'returnTo.label' | portalTranslate }}</span>
          @if (state.label) {
            <span> {{ state.label | portalTranslate }}</span>
          }
        </small>
      </portal-link>
    </p>
  }
}
